import { render } from "./BaseLobby.vue?vue&type=template&id=7b871b5f"
import script from "./BaseLobby.vue?vue&type=script&lang=js"
export * from "./BaseLobby.vue?vue&type=script&lang=js"

import "./BaseLobby.vue?vue&type=style&index=0&id=7b871b5f&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__